// extracted by mini-css-extract-plugin
export default {"root":"ModalTitle_root__lNkNa"};